import React from 'react';

/**
 * What's New never breaks the page it sits on: if the pop-up or the drawer throws while rendering
 * (an announcement shaped in a way this build doesn't expect), it renders nothing and reports it.
 */
class WhatsNewBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { failed: false, resetKey: this.props.resetKey };
    }
    static getDerivedStateFromProps(props, state) {
        return props.resetKey === state.resetKey ? null : { failed: false, resetKey: props.resetKey };
    }
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch(error) {
        var _a, _b;
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
    }
    render() {
        return this.state.failed ? null : React.createElement(React.Fragment, null, this.props.children);
    }
}

export { WhatsNewBoundary };
